import axios from 'axios'

const state = {
  isLoggedIn: false,
  token: null,
  user: null,
  referrals: []
}

const actions = {
  REGISTER ({ commit, state }, user) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_BASE_URL + 'api/register/', user)
        .then((response) => {
          // commit('SET_TOKEN', response.data.api_token.key)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  LOGIN ({ commit, dispatch, state }, user) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_BASE_URL + 'api/auth/', user)
        .then((response) => {
          commit('SET_TOKEN', response.data.token)
          dispatch('LOAD_USER')
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  LOAD_USER ({ commit, state }) {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {
          Authorization: 'Token ' + state.token
        }
      }
      axios.get(process.env.VUE_APP_BASE_URL + 'api/me/', config)
        .then((response) => {
          commit('SET_USER', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  LOAD_REFERRALS ({ commit, state }) {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {
          Authorization: 'Token ' + state.token
        }
      }
      axios.get(process.env.VUE_APP_BASE_URL + 'api/me/referrals/', config)
        .then((response) => {
          commit('SET_REFERRALS', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  PASSWORD_RESET ({ commit, state }, user) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_BASE_URL + 'api/me/password/reset/', user)
        .then((response) => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  PASSWORD_CHANGE ({ commit, state }, form) {
    let config = {
      headers: {
        Authorization: 'Token ' + state.token
      }
    }
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_BASE_URL + 'api/me/password/', form, config)
        .then((response) => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  ACTIVATE ({ commit, dispatch }, code) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_BASE_URL + 'api/me/activate/', { key: code })
        .then((response) => {
          commit('SET_TOKEN', response.data.token)
          dispatch('LOAD_USER')
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  LOGOUT ({ commit }) {
    window.location.href = window.location.href
    localStorage.removeItem('token')
  }
}

const getters = {
  authToken: state => {
    return state.token
  }
}

const mutations = {
  SET_TOKEN (state, payload) {
    state.token = payload
    state.isLoggedIn = true
  },

  SET_USER (state, payload) {
    state.user = payload
    state.isLoggedIn = true
  },

  SET_REFERRALS (state, payload) {
    state.referrals = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
